export default function PrivacyPolicy() {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="bg-[#0E1F3B]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-white">
            Privacy Policy & Terms
          </h1>
          <p className="mt-4 text-gray-300 max-w-3xl leading-relaxed">
            This Privacy Policy explains how Blackthorn Chambers collects,
            uses, and protects information provided by users.
          </p>
        </div>
      </section>

      {/* ================= CONTENT SECTION ================= */}
      <section className="bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 py-20 space-y-8 text-gray-800 leading-relaxed">

          <p>
            <strong>Blackthorn Chambers</strong> is committed to protecting the
            privacy and confidentiality of all users who access our website.
            This Privacy Policy outlines how information is collected, used,
            stored, and protected when you visit or interact with our website.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Information We Collect
          </h2>
          <p>
            We may collect personal information such as name, contact details,
            email address, and any information voluntarily submitted through
            contact or inquiry forms. We may also collect limited non-personal
            information such as browser type, IP address, and website usage
            data for analytical purposes.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Use of Information
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Responding to inquiries or requests made by users</li>
            <li>Providing legal information upon request</li>
            <li>Internal record keeping and administrative purposes</li>
            <li>Improving website functionality and user experience</li>
          </ul>
          <p>
            We do not sell, rent, or share personal information with third
            parties, except where required by law or regulatory authorities.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Data Security
          </h2>
          <p>
            We implement reasonable administrative and technical safeguards to
            protect information against unauthorized access, disclosure,
            alteration, or destruction. However, no method of transmission
            over the internet is entirely secure.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Confidentiality
          </h2>
          <p>
            Accessing this website or submitting information does not create a
            lawyer–client relationship. Users are advised not to share
            confidential or sensitive information unless a formal engagement
            has been confirmed in writing.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Third-Party Links
          </h2>
          <p>
            This website may contain links to third-party websites. Blackthorn
            Chambers does not control or assume responsibility for the content,
            privacy practices, or security of such external websites.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Changes to Privacy Policy
          </h2>
          <p>
            Blackthorn Chambers reserves the right to update or modify this
            Privacy Policy at any time without prior notice. Continued use of
            the website constitutes acceptance of such changes.
          </p>

          {/* ================= TERMS & CONDITIONS ================= */}

          <h2 className="text-3xl font-bold text-[#123a6f] pt-10">
            Terms and Conditions
          </h2>

          <p>
            By accessing and using this website, you agree to be bound by the
            following Terms and Conditions. If you do not agree, you are
            advised to discontinue use of the website.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            No Advertisement or Solicitation
          </h3>
          <p>
            In compliance with the rules of the Bar Council of India, this
            website does not constitute advertisement or solicitation of legal
            services. All content is provided for informational and educational
            purposes only.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            No Legal Advice
          </h3>
          <p>
            The information on this website does not constitute legal advice or
            opinion. Users should seek independent legal counsel for specific
            legal issues.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            No Lawyer–Client Relationship
          </h3>
          <p>
            Use of this website, including submitting inquiries or emails, does
            not establish a lawyer–client relationship unless expressly agreed
            to in writing by Blackthorn Chambers.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            Intellectual Property
          </h3>
          <p>
            All content on this website, including text, logos, graphics, and
            design elements, is the intellectual property of Blackthorn
            Chambers and may not be reproduced, distributed, or used without
            prior written permission.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            Limitation of Liability
          </h3>
          <p>
            Blackthorn Chambers shall not be liable for any direct or indirect
            loss, damage, or inconvenience arising from the use of or reliance
            on information provided on this website.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            User Conduct
          </h3>
          <p>
            Users agree not to misuse the website, introduce malicious code,
            attempt unauthorized access, or use the website for unlawful
            purposes.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            Governing Law and Jurisdiction
          </h3>
          <p>
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of India. Courts located in India shall
            have exclusive jurisdiction over any disputes.
          </p>

          <h3 className="text-xl font-semibold text-[#123a6f]">
            Acceptance of Terms
          </h3>
          <p>
            By accessing this website, you acknowledge that you have read,
            understood, and agreed to this Privacy Policy and Terms and
            Conditions.
          </p>

          <div className="pt-8 border-t border-gray-300">
            <p className="font-semibold text-gray-900">
              Blackthorn Chambers
            </p>
            <p className="text-sm text-gray-600">
              Advocates & Legal Consultants
            </p>
          </div>

        </div>
      </section>
    </>
  );
}
